/* eslint-disable react-hooks/exhaustive-deps */
import { Row, Col, Button, Form, Input, Card, Divider } from "antd";
import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { State } from "../../../../model/application/state";
import { APIrequest } from "../../../../model/client/request";
import { RegistrationPage } from "../../../../service/action/merchant";
import logo from "../../../../images/logo.svg";
import { RegistrationAlert } from "./alert";
import { TiArrowBack } from "react-icons/ti";
import { ImForward } from "react-icons/im";

type RequiredMark = boolean | "optional";

export const Registration: React.FC = () => {
  const requiredMark: RequiredMark = "optional";
  const dispatch = useDispatch();
  const { merchantsRegistrationState }: any = useSelector((state) => state);
  const state: State.RegistrationPage = merchantsRegistrationState;
  const setRegistration = useCallback(
    (
      state: State.RegistrationPage,
      value: any,
      key: keyof APIrequest.MerchantRegistration
    ) => {
      dispatch({
        type: RegistrationPage.Set_Registration_Page_State,
        payload: {
          ...state,
          request: {
            ...state.request,
            [key]: value,
          },
        },
      });
    },
    [state]
  );

  const [showNextRegistration, setShowNextRegistration] = useState(false);

  const onFinish = useCallback(
    (state: State.RegistrationPage) => {
      dispatch({
        type: RegistrationPage.Create_Merchant,
        payload: {
          ...state,
          processing: true,
        },
      });
    },
    [state]
  );

  const validateUser = useCallback(() => {
    dispatch({
      type: RegistrationPage.Validate_User,
      payload: {
        ...state,
      },
    });
  }, [state]);

  useEffect(() => {
    validateUser();
  }, []);

  return (
    <section className="min-h-[100svh] flex justify-center items-center flex-col bg-[#F5F6FA]">
      <RegistrationAlert />
      <div style={{ margin: "0 auto" }}>
        <img src={logo} className="w-44 mb-5" alt="logo" />
      </div>
      <Card className="w-[95%!important] max-w-[30rem!important]">
        <p style={{ fontWeight: 600, textAlign: "center", fontSize: 15 }}>
          Create account to continue
        </p>
        <Form
          style={{ width: "100%" }}
          name="registration"
          layout="vertical"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          requiredMark={requiredMark}
          onFinish={() => onFinish(state)}
          fields={[
            {
              name: ["businessName"],
              value: state.request?.businessName,
            },
            {
              name: ["rcNo"],
              value: state.request?.rcNo,
            },
            {
              name: ["businessPhoneNumber"],
              value: state.request?.businessPhoneNumber,
            },
            {
              name: ["businessAddress"],
              value: state.request?.businessAddress,
            },
            {
              name: ["businessEmail"],
              value: state.request?.businessEmail,
            },
          ]}
        >
          <Row style={{ width: "100%" }}>
            {showNextRegistration ? (
              <div style={{ width: "100%" }}>
                <Divider
                  orientation="left"
                  plain
                  style={{
                    borderColor: "#2B872B",
                    color: "green",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  Business Details
                </Divider>

                <Col style={{ width: "100%" }} span={24} className="gutter-row">
                  <Form.Item
                    name="businessName"
                    label={<span style={{ fontWeight: 600 }}>Name</span>}
                    rules={[
                      { required: true, message: "Name is required" },
                      { min: 3, message: "Name must be at least 3 characters" },
                    ]}
                  >
                    <Input
                      onChange={(e) =>
                        setRegistration(
                          state,
                          e.target.value?.replace(
                            /[-[\]{}()*+?.@,\\^$!0-9/%><`~^&*()_+|#\s]/g,
                            " "
                          ),
                          "businessName"
                        )
                      }
                    />
                  </Form.Item>
                </Col>
                <Col style={{ width: "100%" }} span={24} className="gutter-row">
                  {/* <Form.Item
                    name="businessPhoneNumber"
                    label={
                      <span style={{ fontWeight: 600 }}>Phone Number</span>
                    }
                    rules={[
                      { required: true },
                      {
                        required: true,
                        pattern: new RegExp("[7-9]{1}[0-9]{9}"),
                        message: "Phone number is invalid",
                      },
                    ]}
                  >
                    <Input
                      style={{ fontWeight: 600 }}
                      addonBefore="NGN(+234)"
                      maxLength={10}
                      onChange={(e) =>
                        setRegistration(
                          state,
                          e.target.value,
                          "businessPhoneNumber"
                        )
                      }
                      typeof="tel"
                      minLength={10}
                      pattern="{1}[0-9]{11,14}"
                      placeholder="9000000000"
                    />
                  </Form.Item> */}
                  <Form.Item
                    name="businessPhoneNumber"
                    label={
                      <span style={{ fontWeight: 600 }}>Phone Number</span>
                    }
                    rules={[
                      { required: true, message: "Phone number is required" },
                      {
                        pattern: new RegExp(/^(70|80|90|91|81)[0-9]{8}$/),
                        message: "Phone number is invalid",
                      },
                    ]}
                  >
                    <Input
                      style={{ fontWeight: 600 }}
                      addonBefore="NGN(+234)"
                      maxLength={10}
                      minLength={10}
                      type="tel"
                      placeholder="9000000000"
                      onChange={(e) =>
                        setRegistration(
                          state,
                          e.target.value,
                          "businessPhoneNumber"
                        )
                      }
                    />
                  </Form.Item>
                </Col>
                <Col style={{ width: "100%" }} span={24} className="gutter-row">
                  <Form.Item
                    name="rcNo"
                    label={<span style={{ fontWeight: 600 }}>RC No</span>}
                  >
                    <Input
                      onChange={(e) =>
                        setRegistration(
                          state,
                          e.target.value?.toUpperCase(),
                          "rcNo"
                        )
                      }
                      placeholder="RC00000"
                    />
                  </Form.Item>
                </Col>
                <Col style={{ width: "100%" }} span={24} className="gutter-row">
                  {/* <Form.Item
                    name="businessAddress"
                    label={<span style={{ fontWeight: 600 }}>Address</span>}
                    rules={[{ required: true }]}
                  >
                    <Input
                      onChange={(e) =>
                        setRegistration(
                          state,
                          e.target.value,
                          "businessAddress"
                        )
                      }
                    />
                  </Form.Item> */}
                  <Form.Item
                    name="businessAddress"
                    label={<span style={{ fontWeight: 600 }}>Address</span>}
                    rules={[
                      {
                        required: true,
                        message: "Please enter your business address",
                      },
                      {
                        validator: (_, value) => {
                          if (!value || value.trim().split(/\s+/).length < 10) {
                            return Promise.reject(
                              new Error(
                                "Address must contain at least 10 words"
                              )
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <Input
                      onChange={(e) =>
                        setRegistration(
                          state,
                          e.target.value,
                          "businessAddress"
                        )
                      }
                    />
                  </Form.Item>
                </Col>
                <Col style={{ width: "100%" }} span={24} className="gutter-row">
                  <Form.Item
                    name="businessEmail"
                    label={<span style={{ fontWeight: 600 }}>Email</span>}
                    rules={[
                      {
                        required: true,
                        message: "Please enter your business email",
                      },
                      {
                        pattern: new RegExp(
                          /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
                        ),
                        message: "Invalid Email",
                      },
                    ]}
                  >
                    <Input
                      type="email"
                      onChange={(e) =>
                        setRegistration(state, e.target.value, "businessEmail")
                      }
                    />
                  </Form.Item>
                </Col>
              </div>
            ) : (
              <div style={{ width: "100%" }}>
                <Divider
                  orientation="left"
                  plain
                  style={{
                    borderColor: "#2B872B",
                    color: "green",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  Contact Details
                </Divider>

                <Col style={{ width: "100%" }} span={24} className="gutter-row">
                  <Form.Item
                    style={{ width: "100%" }}
                    label={<span style={{ fontWeight: 600 }}>First Name</span>}
                    rules={[{ required: true }]}
                  >
                    <Input value={state.request?.firstName} readOnly />
                  </Form.Item>
                </Col>
                <Col style={{ width: "100%" }} span={24} className="gutter-row">
                  <Form.Item
                    label={<span style={{ fontWeight: 600 }}>Last Name</span>}
                    rules={[{ required: true }]}
                  >
                    <Input value={state.request?.lastName} readOnly />
                  </Form.Item>
                </Col>
                <Col style={{ width: "100%" }} span={24} className="gutter-row">
                  <Form.Item
                    label={
                      <span style={{ fontWeight: 600 }}>Email Address</span>
                    }
                    rules={[{ required: true }]}
                  >
                    <Input value={state.request?.email} readOnly />
                  </Form.Item>
                </Col>
                <Col style={{ width: "100%" }} span={24} className="gutter-row">
                  <Form.Item
                    label={
                      <span style={{ fontWeight: 600 }}>Phone Number</span>
                    }
                    rules={[{ required: true }]}
                  >
                    <Input value={state.request?.phoneNumber} readOnly />
                  </Form.Item>
                </Col>
              </div>
            )}
            {showNextRegistration ? (
              <span className="flex w-full justify-between items-center">
                <Button
                  type="default"
                  onClick={() => setShowNextRegistration(!showNextRegistration)}
                  className="flex gap-1 items-center"
                >
                  <TiArrowBack />
                  Previous
                </Button>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="flex gap-3 items-center float-right"
                  loading={state.processing}
                >
                  Submit
                </Button>
              </span>
            ) : (
              <Button
                block
                type="primary"
                onClick={() => setShowNextRegistration(!showNextRegistration)}
                className="flex gap-3 items-center justify-center py-5"
              >
                Next <ImForward />
              </Button>
            )}
          </Row>
        </Form>
      </Card>
      <Col span={24}>
        <div className="mx-auto text-md text-center">
          Do you have an account?
          {
            <Button
              style={{ color: "green", border: "none" }}
              onClick={() =>
                (window.location.href = localStorage.getItem("$$$$") ?? '')
              }
              type="text"
            >
              Login
            </Button>
          }
        </div>
      </Col>
    </section>
  );
};
